import {
  Stack, SimpleGrid, Skeleton,
} from '@mantine/core';
import { IconReceipt } from '@tabler/icons-react';
import PageHeader from '@/components/PageHeader';
import StatCard from '@/components/StatCard';
import EmptyState from '@/components/EmptyState';
import { useAPAgingReport } from '@/hooks/usePortalApi';

function formatCurrency(val: number) {
  return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(val);
}

export default function APAging() {
  const { data, isLoading } = useAPAgingReport();

  return (
    <Stack gap="lg">
      <PageHeader title="AP Aging" description="Accounts payable aging summary" />
      {isLoading ? (
        <SimpleGrid cols={{ base: 1, sm: 2, lg: 4 }}>
          {[...Array(4)].map((_, i) => <Skeleton key={i} height={120} radius="md" />)}
        </SimpleGrid>
      ) : !data ? (
        <EmptyState icon={<IconReceipt size={30} />} title="No AP aging data" description="No accounts payable aging data available" />
      ) : (
        <SimpleGrid cols={{ base: 1, sm: 2, lg: 4 }}>
          <StatCard
            title="Current"
            value={formatCurrency(data.current ?? 0)}
            icon={<IconReceipt size={24} />}
          />
          <StatCard
            title="1-30 Days"
            value={formatCurrency(data.days_1_30 ?? 0)}
            icon={<IconReceipt size={24} />}
          />
          <StatCard
            title="31-60 Days"
            value={formatCurrency(data.days_31_60 ?? 0)}
            icon={<IconReceipt size={24} />}
          />
          <StatCard
            title="61-90 Days"
            value={formatCurrency(data.days_61_90 ?? 0)}
            icon={<IconReceipt size={24} />}
          />
          <StatCard
            title="Over 90 Days"
            value={formatCurrency(data.over_90 ?? 0)}
            icon={<IconReceipt size={24} />}
          />
          <StatCard
            title="Total Outstanding"
            value={formatCurrency(data.total ?? 0)}
            icon={<IconReceipt size={24} />}
          />
        </SimpleGrid>
      )}
    </Stack>
  );
}
